import React from 'react'

export default ({
  className = '',
  onClick
}) => (
<svg className={className}  onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="63.488" height="84.651" viewBox="0 0 63.488 84.651"><path className="a" d="M31.28-10.5V47.918L12.652,29.29l-5.07,5.07,24.69,24.69,2.535,2.425,2.535-2.425,24.69-24.69-5.07-5.07L38.334,47.918V-10.5ZM3.063,67.1v7.054H66.551V67.1Z" transform="translate(-3.063 10.5)"/></svg>
)
